export const attachLocaleToUrl = (url: string, locale: string = 'de-DE'): string => {
    if (!url) {
        throw new Error('URL cannot be empty');
    }

    try {
        const url_object = new URL(url);
        url_object.searchParams.set('locale', locale);
        return url_object.toString();
    } catch {
        throw new Error(`Invalid URL: ${url}`);
    }
};
